var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-buy" },
    [
      _c("div", { staticClass: "buy-tap", attrs: { id: "buy_display" } }, [
        _c(
          "div",
          { staticClass: "buy-tap-item clearfix" },
          [
            _c("BuyTapFree", { on: { viewDetail: _vm.viewDetail } }),
            _vm._v(" "),
            _c("BuyTapPro", {
              attrs: {
                upgradeVersion: _vm.upgradeVersion,
                modalShow: _vm.modalShow
              },
              on: { viewDetail: _vm.viewDetail }
            }),
            _vm._v(" "),
            _c("BuyTapAdvance", {
              attrs: {
                upgradeVersion: _vm.upgradeVersion,
                modalShow: _vm.modalShow
              },
              on: { viewDetail: _vm.viewDetail }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { closeable: false, modalInfo: _vm.modalInfo },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c("BuyDetail", {
            attrs: { coupon: _vm.coupon, version: _vm.version },
            on: {
              closeDetail: _vm.closeDetail,
              recommendAnnual: _vm.recommendAnnual
            }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { closeable: false },
          model: {
            value: _vm.irresistibleModalShow,
            callback: function($$v) {
              _vm.irresistibleModalShow = $$v
            },
            expression: "irresistibleModalShow"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c("IrresistibleDiscountModal", {
            attrs: { coupon: _vm.coupon },
            on: { close: _vm.closeDetail }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { closeable: true },
          model: {
            value: _vm.extraFeeModalShow,
            callback: function($$v) {
              _vm.extraFeeModalShow = $$v
            },
            expression: "extraFeeModalShow"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c("ExtraFeeModal", {
            attrs: { coupon: _vm.coupon, plan: _vm.plan, payUrl: _vm.payUrl },
            on: { payAnnual: _vm.payAnnual, closeDetail: _vm.closeDetail }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }